import "../css/eventsList.css";
import OtherProfileForm from "./otherProfile.js";
import EventReportForm from "./reportEvent.js";
import CommentCard from "./commentCard.js"
import CommentForm from "./commentForm.js"
// import "../css/signup.css";
import "../css/comments.css";
import React, { useState } from "react";
import NetworkList from './networklist.js';
import {BASE_URL} from "../constants"
import { useLanguage } from "../components/Language.js";

function EventCard({onclose, event_id, title, description, start_time, end_time, start_date, end_date, postcode, latitude, longitude, event_picture, 
    event_proficiency, type, age_bracket, language, host_username, host_name, check_ins, number_likes, performCheckinUpdate, 
    performLikeUpdate, fetchEvents, handleEdit, user, onDeleteSuccess}) {
    
    const [otherProfileData, setOtherProfileData] = useState(null);
    const [comments, setComments] = useState([]);

    const [isOtherProfileVisible, setIsOtherProfileVisible] = useState(false);
    const [isReportVisible, setIsReportVisible] = useState(false);
    const [isCommentTabVisible, setIsCommentTabVisible] = useState(false);
    const [isExtraVisible, setIsExtraVisible] = useState(false);
    const [showNetwork, setShowNetwork] = useState(false);

    const {language: selectedLanguage} = useLanguage();

    const translations = {
      en: {
        eventDeleted: "Event Deleted",
        edit: "Edit",
        delete: "Delete",
        report: "Report",
        hideYourNetwork: "Hide Your Network",
        inviteYourNetwork: "Invite Your Network",
        showEventDetails: "Show Event Details v",
        hideEventDetails: "Hide Event Details ʌ",
        location: "Location",
        hostedBy: "Hosted By",
        checkIn: "Check In",
        viewComments: "View Comments",
        hideResponses: "Hide Responses",
        noComments: "This event has no comments yet, write the first!",
        showingAllComments: "Showing all comments",
        startTime: "Start Time: ",
        endTime: "End Time: ",
        startDate: "Start Date: ",
        endDate: "end Date: ",
        proficencyLevel: "Proficency Level: ",
        ageBracket: "Age Bracket: ",
        language: "Language: ",
        postcode: "Postcode: ",
        like: "Like",
      },

      gd: {
        eventDeleted: "Tachartas dubhte às",
        edit: "Deasaich",
        delete: "Dubh às",
        report: "Aithris",
        hideYourNetwork: "Falaich do Lìonra",
        inviteYourNetwork: "Thoir cuireadh dod Lìonra",
        showEventDetails: "Seall  Fiosrachadh an Tachartais v",
        hideEventDetails: "Falaich Fiosrachadh an Tachartais ʌ",
        location: "Àite",
        hostedBy: "Air Aoigheachd bho",
        checkIn: "Clàir",
        viewComments: "Thoir sùil air na h-Abairtean",
        hideResponses: "Falaich na Freagairtean",
        noComments: "Chan eil beachdan ann mun tachartas seo fhathast, sgrìobh a' chiad fhear!",
        showingAllComments: "Taisbeanadh nan abairtean uile",   
        startTime: "Àm tòiseachaidh: ",
        endTime: "Àm crìochnachaidh: ",
        startDate: "Ceann-latha tòiseachaidh: ",
        endDate: "Ceann-latha crìochnachaidh: ",
        proficencyLevel: "Ìre Comais: ",
        ageBracket: "Raon aoise: ",
        language: "Cànan: ",
        postcode: "Còd-puist",
        like: "Is toigh leam seo",
      },
  };

    let username = (sessionStorage.getItem("USER") === null ? null : JSON.parse(sessionStorage.getItem("USER"))['username']);

    let typeArray = [];
      typeArray = type.replace(/['"]+/g, '').replace('[', '').replace(']', '').split(",")

    console.log("id:", event_id);

    const handleToggleNetwork = () => {
      setShowNetwork(!showNetwork);
  };

    const handleDelete = async (event_id) => {

      const confirmDelete = window.confirm("Are you sure you want to delete this event? This action cannot be undone.");

      if (!confirmDelete) {
        return;
    }

      const response = await fetch(`${BASE_URL}/api/delete_event/`, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        },
      body: JSON.stringify({ 
            "event_id": event_id,
            
       }),
    });

    const data = await response.json();

    if (data.status === 'success') {
      // onDeleteSuccess();
      alert(`${translations[selectedLanguage].eventDeleted}`);
      onclose();
    }
    else {
      console.log("Failed to delete")
    }
  };

    const fetchProfileData = async (username) => {
    
      const response = await fetch(`${BASE_URL}/api/gather_profile_data/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username }),
      });
      const data = await response.json();

      setOtherProfileData(data);
      setIsOtherProfileVisible(true);
    }

    const fetchComments = async () => {

      const type = "event";

      console.log("type: ", type)

        try{
            const response = await fetch(
            `${BASE_URL}/api/comments/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
  
              body: JSON.stringify({
                type: type, 
                event_id: event_id,
              }),
            });
  
            const data = await response.json();
            setComments(data);

            setIsCommentTabVisible(true);
            setIsOtherProfileVisible(false);
  
        } catch (error) {
            console.error('Error fetching comments:', error);
        }
  
    };


    //like comment
    async function performCommentLike(comment_id, username) { 

        await fetch(`${BASE_URL}/api/like_comment/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ comment_id: comment_id, username: username }),
        });
    
      };



    function handleManualCheckIn(event_id) {
        let username = JSON.parse(sessionStorage.getItem("USER"))['username']
        performCheckinUpdate(event_id, username);
        setTimeout(fetchEvents, 500);
    }

    function handleLike(event_id) {
        let username = JSON.parse(sessionStorage.getItem("USER"))['username']
        performLikeUpdate(event_id, username);
        setTimeout(fetchEvents, 500);
    }


    return(

        <div className="event-card">

          <div className="event-card-header">
            <h4 className = "event-title">{title} </h4>

            <div>
            {(username === host_username || user?.admin) && (
              <button 
                onClick={() => handleEdit(event_id)} 
                id="edit-button"
              > 
                {translations[selectedLanguage].edit}
              </button>
            )}

            {username === host_username && (
              <button 
                onClick={handleToggleNetwork}
                id="network-button">
                  {showNetwork ? `${translations[selectedLanguage].hideYourNetwork}` : `${translations[selectedLanguage].inviteYourNetwork}`}
              </button>
            )}

            {(username !== null) && (
              <button
                onClick = {() => setIsReportVisible(!isReportVisible)}
                id="report-button"
              >
                  {translations[selectedLanguage].report}
              </button>
            )}

            {(username === host_username || user?.admin ) && (
              <button 
                onClick={() => handleDelete(event_id)} 
                id="delete-event-button"
              > 
                {translations[selectedLanguage].delete}
              </button>
            )}
            
            </div>


          </div>

          <img className = "event-image" src = {event_picture} alt = "event image" />
          <div className="time-and-date-container">
            <p className = "event-start-time">{translations[selectedLanguage].startTime} {start_time.slice(0, -3)} </p>
            <p className = "event-end-time">{translations[selectedLanguage].endTime} {end_time.slice(0, -3)} </p>
            <p className = "event-start-date">{translations[selectedLanguage].startDate} {new Date(start_date).toLocaleDateString("en-UK")}</p>
            <p className = "event-end-date">{translations[selectedLanguage].endDate} {new Date(end_date).toLocaleDateString("en-UK")}</p>

            {typeArray.map((tag, index) => (
                  <p className="event-tag" key={index}>{tag}</p>
            ))}
          </div>


          <h5 className = "event-description">{description}</h5>
          {/* <p className = "event-check-ins">check ins: {check_ins}</p>
          <p className = "event-likes">number likes: {number_likes}</p> */}

          {!isExtraVisible ? (
            <button className = "toggle-extra" onClick={() => setIsExtraVisible(true)}> {translations[selectedLanguage].showEventDetails} </button>
          ):(
            <>
            <button className = "toggle-extra" onClick={() => setIsExtraVisible(false)}> {translations[selectedLanguage].hideEventDetails} </button>
            <p className = "proficiency">{translations[selectedLanguage].proficencyLevel} {event_proficiency}</p>
            <p className = "age-bracket">{translations[selectedLanguage].ageBracket} {age_bracket}</p>
            <p className = "language">{translations[selectedLanguage].language} {language}</p>
            <p className = "event-postcode">{translations[selectedLanguage].location} {postcode}</p>
            </>
          )}
         
          <p className="event-host">
          {translations[selectedLanguage].hostedBy} 
            {username !== null ? (
              <button className="view-profile" onClick={() => fetchProfileData(host_username)}>
                {host_name} ({host_username})
              </button>
            ):(
              " " + host_name
            )}
          </p>

      {(username !== null) && (
        <button 
          onClick={() => handleManualCheckIn(event_id)} 
          id="check-in-button"
        > 
          {translations[selectedLanguage].checkIn} ({check_ins})
        </button>
      )}

      {(username !== null) && (
        <button 
          onClick={() => handleLike(event_id)} 
          id="like-button"
        > 
          {translations[selectedLanguage].like} ({number_likes})
        </button>
      )}


        {!isCommentTabVisible && (
            <button 
              onClick={() => {fetchComments();}}
              id = "view-comments-button"
            >
              {translations[selectedLanguage].viewComments}
            </button>
        )}

        {isCommentTabVisible && (
            <button 
              onClick={() => setIsCommentTabVisible(false)}
              id = "view-comments-button"
            >
              {translations[selectedLanguage].hideResponses}
            </button>
        )}


        {isOtherProfileVisible && (
        // <div className="signup-form-container active">
          <OtherProfileForm
            otherProfileData={otherProfileData}
            user={JSON.parse(sessionStorage.getItem("USER"))}
            onClose={() => setIsOtherProfileVisible(false)}
          />
        
        )}

        {isReportVisible && (
            <EventReportForm 
              event_id = {event_id}
              event_title = {title}
              onClose= {() => setIsReportVisible(false)}
            />
        )}

        {showNetwork && ( 
          <NetworkList 
            username={username}
            fromEvent={true}
            fromProfile={false}
            eventId={event_id}
            onClose={() => setShowNetwork(false)} 
          />
        )}

        {isCommentTabVisible && (
            <div>

            {comments.length === 0 && (
                <p className="no-comments">{translations[selectedLanguage].noComments}</p>
            )}

            {!comments.length == 0 && ( 
                <p className="comment-info">{translations[selectedLanguage].showingAllComments} </p>
            )}

            {comments.map(comment => {
                return(

                    <div>
                    <CommentCard 
                        onclose={setIsCommentTabVisible}
                        comment_id = {comment.id}
                        content={comment.content} 
                        image ={comment.image}
                        video={comment.video}
                        date_created={comment.date_created} 
                        number_likes={comment.likes}
                        event_name = {comment.event}
                        author={comment.author}
                        author_picture={comment.author_picture}
                        performCommentLike = {performCommentLike}
                        fetchComments= {fetchComments}
                    />
                  
                    </div>
                )
            })}

            <CommentForm 
              type = {"event"}
              event_id = {event_id}
              comments={comments} 
              fetchComments = {fetchComments}
            />

            </div>
        )}

      </div>
    )
};


export default EventCard;